import { combineReducers } from 'redux';

import users from './users';
import session from './session';
import collections from './collections';
import statistics from './statistics';
import accessRequest from './accessRequests';
import userCollection from './userCollection';
import drivers from './drivers';
import appConfig from './appConfig';
import changeRequest from './changeRequests';
import institutions from './institutions';
import internalDocuments from './internalDocuments';
import expressions from './expressions'
import emailParams from './emailsParams';
import systems from './systems';
import domains from './domains';
import fileSystem from './fileSystem';
import systemRequest from './systemRequests';
import ingestorMonitoring from './ingestorMonitoring';
import pipelines from './pipelines';
import pipelinesAccess from './pipelinesAccess';

// O nome definido aqui, vai ser utilizado para buscar o state no reducer
export default combineReducers({
  users,
  session,
  collections,
  statistics,
  accessRequest,
  userCollection,
  drivers,
  appConfig,
  changeRequest,
  institutions,
  internalDocuments,
  systems,
  domains,
  expressions,
  emailParams,
  fileSystem,
  systemRequest,
  ingestorMonitoring,
  pipelines,
  pipelinesAccess
});
